import { api } from '@/shared/lib/api'
import { useQuery } from '@tanstack/react-query'

export const useSearchHistories = (enabled: boolean = true) => {
    return useQuery({
        queryKey: ['search-histories'],
        queryFn: () => api.searchGlobal.histories(),
        enabled,
    })
}
